import { Component } from '@angular/core';
import { NavigationService } from "./navigation.service";
import { Observable } from "rxjs";
import { NavigationItemInterface } from "./common/navigation-item.interface";
import { BasicUserData } from '../../common/models/user/basic-user-data';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'psc-navigation',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {

  navigationItems$: Observable<NavigationItemInterface[]> = this.navigationService.getNavigationItemsObservable();

  userData: Observable<BasicUserData | null> = this.authService.getUserDataObservable();
  constructor(
    private navigationService: NavigationService,
    private authService: AuthService,
  ) {
  }

}
